export interface Events<T> {
	added: [readonly T[], number]
	removed: [T[], number]
	replaced: [T[], T[], number]
	changed: [readonly T[]]
}
export namespace Events {
	export const values: (keyof Events<any>)[] = ["added", "removed", "replaced", "changed"]
}
